import { render } from "./BannerUpdatePhoto.vue?vue&type=template&id=311c6d2a"
import script from "./BannerUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./BannerUpdatePhoto.vue?vue&type=script&lang=js"

import "./BannerUpdatePhoto.vue?vue&type=style&index=0&id=311c6d2a&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__